export * from '../../types/data/screening-questions/config';
export type { AiSuggestionItem } from '../../types/data/screening-questions/types';
import { baseScreeningQuestionsConfig } from '../../types/data/screening-questions/config';
export const patientScreeningQuestionsConfig = baseScreeningQuestionsConfig;
